import { languageMenuStyles } from "@insite/content-library/Widgets/Common/LanguageMenu";
import Globe from "@insite/mobius/Icons/Globe";
import { css } from "styled-components";

languageMenuStyles.languageIcon = {
    size: 22,
    src: Globe,
    css: css`
        margin-top: -3px;
    `,
};
languageMenuStyles.languageSelect = {
    sizeVariant: "small",
    backgroundColor: "common.accent",
    cssOverrides: {
        formInputWrapper: css`
            width: 135px;
            
        `,
        inputSelect: css`
            border: none;
            text-transform: uppercase;
            font-size: 15px !important;
        `,
        
    },
};
